export default function cloneObject(object) {
    return JSON.parseWithDate(JSON.stringify(object));
}
